import { render, staticRenderFns } from "./HalfLayout.vue?vue&type=template&id=f08fe132"
import script from "./HalfLayout.vue?vue&type=script&lang=js"
export * from "./HalfLayout.vue?vue&type=script&lang=js"
import style0 from "./HalfLayout.vue?vue&type=style&index=0&id=f08fe132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports